import React from 'react';

type SvgProps = {
    color?: string;
    size?: number;
};

const HeavyRainIcon: React.FC<SvgProps> = ({ color = "white", size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.7">
            <path d="M102.988 43.396C102.169 43.396 101.349 43.396 100.53 43.5732V43.396C100.53 36.7071 97.5829 30.1926 92.3403 26.3194C87.2626 22.2717 80.7113 21.2142 74.6496 23.3266C69.5719 13.1188 58.5973 7.8363 48.1147 10.652C37.6296 13.2932 30.2591 23.3266 29.9319 34.9464C23.0509 33.5372 15.6804 36.3555 11.0947 42.5156C6.67142 48.6758 5.68735 57.1254 8.63707 64.1687C11.5843 71.3864 17.9732 76.1374 25.3437 76.6662L103.969 76.8433C112.489 76.6662 119.367 68.9197 119.04 59.5923C118.878 50.4366 111.67 43.2189 102.988 43.396Z" fill={color} />
            <rect x="32.1738" y="77.1599" width="5.605" height="16.815" rx="2.8025" transform="rotate(30 32.1738 77.1599)" fill={color} />
            <rect x="48.9883" y="77.1599" width="5.605" height="16.815" rx="2.8025" transform="rotate(30 48.9883 77.1599)" fill={color} />
            <rect x="32.1738" y="96.7773" width="5.605" height="16.815" rx="2.8025" transform="rotate(30 32.1738 96.7773)" fill={color} />
            <rect x="51.791" y="96.7773" width="5.605" height="16.815" rx="2.8025" transform="rotate(30 51.791 96.7773)" fill={color} />
            <rect x="68.6055" y="96.7773" width="5.605" height="16.815" rx="2.8025" transform="rotate(30 68.6055 96.7773)" fill={color} />
            <rect x="85.4219" y="96.7773" width="5.605" height="16.815" rx="2.8025" transform="rotate(30 85.4219 96.7773)" fill={color} />
            <rect x="65.8027" y="77.1599" width="5.605" height="16.815" rx="2.8025" transform="rotate(30 65.8027 77.1599)" fill={color} />
            <rect x="82.6191" y="77.1599" width="5.605" height="16.815" rx="2.8025" transform="rotate(30 82.6191 77.1599)" fill={color} />
            <rect x="99.4336" y="77.1599" width="5.605" height="16.815" rx="2.8025" transform="rotate(30 99.4336 77.1599)" fill={color} />
        </g>
    </svg >




);

export default HeavyRainIcon;
